import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { forkJoin } from 'rxjs';
import { FileUpload } from 'primeng/fileupload';
import { NavService } from '../../_services/_nav.service';
import { AdjuntoService } from '../../_services/adjunto.service';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { AppSettings } from '../../../proyect.conf';
import { ProductoTroncalService } from '../../_services/producto-troncal.service';
import { ProductoTroncal } from '../../_models/producto-troncal';
import { ProductoTroncalProductoAgrupadoService } from '../../_services/producto-troncal-producto-agrupado.service';
import { ProductoTroncalProductoAgrupado } from '../../_models/producto-troncal-producto-agrupado';
import { ProductosTroncalProductosComponent } from './productos-troncal-productos/productos-troncal-productos.component';

@Component({
  selector: 'app-productos-troncal-editar',
  templateUrl: './productos-troncal-editar.component.html',
  styleUrls: [ './productos-troncal-editar.component.css' ]
})
export class ProductosTroncalEditarComponent implements OnInit {

  carInformacionInicial = true;
  guardando = false;
  submitted = false;
  formulario: FormGroup;

  productoTroncal: ProductoTroncal;
  productosAgrupados: ProductoTroncalProductoAgrupado[] = [];
  productosAgrupadosOriginal: ProductoTroncalProductoAgrupado[] = [];
  productosTroncalExistentes: ProductoTroncal[] = [];
  siguienteOrden = 1;

  lisTiposProducto: SelectItem[] = [];

  imagen: SafeResourceUrl;
  nomArchivoIcono: string;
  subiendoAdjunto = false;
  public svcThUrl = AppSettings.rutServiciosADJ + '/api/adjuntos';
  @ViewChild('adjunto') adjunto: FileUpload;
  @ViewChild( ProductosTroncalProductosComponent ) productosGrid: ProductosTroncalProductosComponent;

  constructor( private route: ActivatedRoute,
               private location: Location,
               private fb: FormBuilder,
               private navServicio: NavService,
               private conServicio: ConfirmationService,
               private sanitizer: DomSanitizer,
               private adjService: AdjuntoService,
               private lisServicio: ListaService,
               private productoTroncalServicio: ProductoTroncalService,
               private productoTroncalProductoAgrupadoServicio: ProductoTroncalProductoAgrupadoService ) {
  }

  ngOnInit(): void {
    this.route.params.subscribe( ( params: Params ) => {
      if ( params[ 'id' ] ) {
        forkJoin(
          this.productoTroncalServicio.obtenerPorId( params[ 'id' ] ),
          this.productoTroncalProductoAgrupadoServicio.listarPorProductoTroncal( params[ 'id' ] )
        ).subscribe( ( [ productoTroncal, agrupados ] ) => {
          this.productoTroncal = productoTroncal;
          this.productosAgrupados = agrupados.filter( x => x.indicadorHabilitado );
          this.productosAgrupadosOriginal = this.productosAgrupados;
          this.cargarServiciosIniciales();
          if ( productoTroncal.idIcono ) {
            this.cargarIcono( productoTroncal.idIcono, productoTroncal.nombreAdjuntoIcono );
          }
        } );
      } else {
        this.cargarServiciosIniciales();
      }
    } );
  }

  cargarServiciosIniciales() {
    this.formulario = this.fb.group( {
      idProductoTroncal: [ this.productoTroncal ? this.productoTroncal.idProductoTroncal : null ],
      codigo: [
        this.productoTroncal ? this.productoTroncal.codigo : null,
        [ Validators.required, Validators.maxLength( 6 ), this.validarCodigoDuplicado ]
      ],
      nombre: [ this.productoTroncal ? this.productoTroncal.nombre : null, [ Validators.required ] ],
      indicadorProducto: [ this.productoTroncal ? this.productoTroncal.indicadorProducto : true ],
      idTipoProducto: [ this.productoTroncal ? this.productoTroncal.idTipoProducto : null ],
      idIcono: [ this.productoTroncal ? this.productoTroncal.idIcono : null, [ Validators.required ] ],
      indicadorHabilitado: [ this.productoTroncal ? this.productoTroncal.indicadorHabilitado : true ],
      orden: [ this.productoTroncal ? this.productoTroncal.orden : null ]
    } );

    this.actualizarValidacionTipoProducto();

    forkJoin(
      this.lisServicio.getMasterDetails( 'ListasTiposProductosBancarios' ),
      this.productoTroncalServicio.listado()
    ).subscribe( ( [ tiposProducto, productosTroncal ]: [ ListaItem[], ProductoTroncal[] ] ) => {
      this.lisTiposProducto = tiposProducto.map( ( s: ListaItem ) => ( { label: s.nombre, value: s.idLista } ) );
      this.productosTroncalExistentes = productosTroncal;
      if ( !this.productoTroncal ) {
        this.siguienteOrden = productosTroncal.length > 0
          ? Math.max( ...productosTroncal.map( p => p.orden ) ) + 1
          : 1;
        this.f.orden.setValue( this.siguienteOrden );
      }
      this.f.codigo.updateValueAndValidity();
      this.carInformacionInicial = false;
    } );
  }

  /**
   * Valida contra la base de datos (el listado ya consultado) si el código
   * ya existe en OTRO registro y está Activo. Si existe pero está
   * inhabilitado, no bloquea: el backend lo reactiva automáticamente al
   * guardar (no es un caso de duplicado).
   */
  validarCodigoDuplicado = ( control: AbstractControl ): ValidationErrors | null => {
    if ( !control.value ) {
      return null;
    }
    const idActual = this.formulario ? this.formulario.value.idProductoTroncal : null;
    const duplicado = this.productosTroncalExistentes.some( p =>
      p.codigo === control.value && p.indicadorHabilitado && p.idProductoTroncal !== idActual );
    return duplicado ? { codigoDuplicado: true } : null;
  };

  actualizarValidacionTipoProducto() {
    if ( this.f.indicadorProducto.value ) {
      this.f.idTipoProducto.clearValidators();
    } else {
      this.f.idTipoProducto.setValidators( [ Validators.required ] );
    }
    this.f.idTipoProducto.updateValueAndValidity();
  }

  cambiarModo() {
    this.actualizarValidacionTipoProducto();
  }

  cargarIcono( idIcono: string, nombre: string ) {
    this.subiendoAdjunto = true;
    this.adjService.descargarArchivo( idIcono ).subscribe( blob => {
      this.nomArchivoIcono = nombre;
      const reader = new FileReader();
      reader.addEventListener( 'load', () => {
        this.imagen = this.sanitizer.bypassSecurityTrustUrl( reader.result.toString() );
        this.subiendoAdjunto = false;
      }, false );
      reader.readAsDataURL( blob );
    }, () => {
      this.subiendoAdjunto = false;
    } );
  }

  onBeforeSend( event: any ) {
    this.subiendoAdjunto = true;
    this.adjService.cargarArchivo( event, this.nomArchivoIcono, 'ProductoTroncalIcono' );
  }

  onSelect( event: any, file: any ) {
    if ( this.adjunto.msgs.length === 0 ) {
      this.nomArchivoIcono = file[ 0 ].name;
      const reader = new FileReader();
      reader.addEventListener( 'load', () => {
        this.imagen = this.sanitizer.bypassSecurityTrustUrl( reader.result.toString() );
      }, false );
      reader.readAsDataURL( file[ 0 ] );
    } else {
      this.navServicio.setMesageArray( this.adjunto.msgs );
    }
  }

  onUpload( event: any ) {
    const respuesta = event.originalEvent.body;
    this.f.idIcono.setValue( respuesta && respuesta.idAdjunto ? respuesta.idAdjunto : null );
    this.subiendoAdjunto = false;
  }

  /**
   * Si la subida del ícono falla (red, servidor), evita que subiendoAdjunto
   * quede en true para siempre — eso dejaría el botón Guardar deshabilitado
   * de forma permanente sin ningún aviso al usuario.
   */
  onErrorUpload( event: any ) {
    this.subiendoAdjunto = false;
    this.navServicio.setMesage( 3 );
  }

  eliminarIcono() {
    this.f.idIcono.setValue( null );
    this.imagen = null;
    this.nomArchivoIcono = null;
  }

  /** Orden que dejaba el inactivo antes de reactivarse (para reorganizar a los demás). */
  private ordenLiberado: number = null;

  /**
   * Productos agrupados que ya tenía el producto troncal reactivado (de cuando
   * estaba activo) y que el usuario no volvió a seleccionar en la grilla de
   * esta alta. Se guardan aquí para deshabilitarlos al construir el lote, y
   * así evitar que convivan con los productos nuevos que sí eligió el usuario.
   */
  private agrupadosHeredadosDeshabilitar: ProductoTroncalProductoAgrupado[] = [];

  /**
   * Si se está creando un producto troncal (sin idProductoTroncal) con un
   * código que coincide con uno inhabilitado, se reutiliza su
   * idProductoTroncal (el guardado pasa a ser una actualización/reactivación
   * real de ese registro, no una creación) y se envía al final de la lista,
   * igual que un producto nuevo. Su puesto anterior queda guardado en
   * `ordenLiberado` para que los demás registros se reorganicen y llenen
   * ese hueco (ver `reorganizarTrasReactivacion`).
   */
  reutilizarInactivoPorCodigo() {
    this.ordenLiberado = null;
    if ( this.f.idProductoTroncal.value ) {
      return;
    }
    const inactivo = this.productosTroncalExistentes.find( p =>
      p.codigo === this.f.codigo.value && !p.indicadorHabilitado );
    if ( inactivo ) {
      this.ordenLiberado = inactivo.orden;
      this.f.idProductoTroncal.setValue( inactivo.idProductoTroncal );
      this.f.orden.setValue( this.productosTroncalExistentes.length );
    }
  }

  /**
   * Recorre los productos troncales cuyo orden era mayor al que dejó libre
   * el recién reactivado y los recorre un puesto hacia atrás (orden - 1),
   * cerrando el hueco. Se persiste en lote contra el backend.
   */
  reorganizarTrasReactivacion( idReactivado: string, callback: () => void ) {
    const afectados = this.productosTroncalExistentes
      .filter( p => p.orden > this.ordenLiberado && p.idProductoTroncal !== idReactivado )
      .map( p => ( { ...p, orden: p.orden - 1 } ) );

    if ( afectados.length === 0 ) {
      callback();
      return;
    }
    this.productoTroncalServicio.crearActualizarLote( afectados ).subscribe( callback, callback );
  }

  onSubmit() {
    this.submitted = true;
    if ( this.subiendoAdjunto ) {
      return;
    }
    if ( !this.formulario.valid ) {
      this.formulario.markAllAsTouched();
      return;
    }
    if ( this.f.indicadorProducto.value && this.productosAgrupados.length === 0 ) {
      return;
    }
    this.guardando = true;
    this.agrupadosHeredadosDeshabilitar = [];
    this.reutilizarInactivoPorCodigo();

    if ( this.ordenLiberado !== null ) {
      // Se reactivó un troncal: puede traer productos agrupados propios de
      // cuando estaba activo (la grilla arrancó vacía y nunca los cargó, sin
      // importar el modo elegido ahora). Se consultan antes de guardar (ver
      // prepararAgrupadosHeredados).
      this.productoTroncalProductoAgrupadoServicio.listarPorProductoTroncal( this.f.idProductoTroncal.value )
        .subscribe( ( agrupadosExistentes: ProductoTroncalProductoAgrupado[] ) => {
          this.prepararAgrupadosHeredados( agrupadosExistentes );
          this.guardarProductoTroncal();
        }, () => {
          this.guardando = false;
        } );
    } else {
      this.guardarProductoTroncal();
    }
  }

  /**
   * De los agrupados que ya tenía el troncal reactivado, decide cuáles
   * deshabilitar:
   * - Modo Producto: los que el usuario no volvió a seleccionar en la
   *   grilla de esta alta (comparando por idProducto). Los que sí coinciden
   *   se dejan intactos y se guardan por el lote normal, sin duplicarlos.
   * - Modo Tipo: todos. Un troncal en modo Tipo no debería conservar
   *   productos agrupados heredados de cuando era modo Producto.
   */
  prepararAgrupadosHeredados( agrupadosExistentes: ProductoTroncalProductoAgrupado[] ) {
    const habilitados = agrupadosExistentes.filter( existente => existente.indicadorHabilitado );
    const aDeshabilitar = this.f.indicadorProducto.value
      ? habilitados.filter( existente => !this.productosAgrupados.find( p => p.idProducto === existente.idProducto ) )
      : habilitados;
    this.agrupadosHeredadosDeshabilitar = aDeshabilitar.map( existente => ( { ...existente, indicadorHabilitado: false } ) );
  }

  guardarProductoTroncal() {
    const registro: ProductoTroncal = { ...this.formulario.value };
    if ( registro.indicadorProducto ) {
      // Modo Producto: idTipoProducto no aplica. Se limpia solo en el
      // payload a enviar (no en el control del formulario) para no perder
      // la selección si el usuario alterna de modo antes de guardar.
      registro.idTipoProducto = null;
    }

    const guardarProductoTroncal$ = registro.idProductoTroncal
      ? this.productoTroncalServicio.actualizar( registro )
      : this.productoTroncalServicio.crear( registro );

    guardarProductoTroncal$.subscribe( ( guardado: ProductoTroncal ) => {
      let lote: ProductoTroncalProductoAgrupado[] = [];

      if ( registro.indicadorProducto ) {
        const eliminados = this.productosGrid ? this.productosGrid.obtenerEliminados() : [];
        lote = [ ...this.productosAgrupados, ...eliminados, ...this.agrupadosHeredadosDeshabilitar ]
          .map( p => ( { ...p, idProductoTroncal: guardado.idProductoTroncal } ) );
      } else if ( this.productosAgrupadosOriginal.length > 0 || this.agrupadosHeredadosDeshabilitar.length > 0 ) {
        // productosAgrupadosOriginal cubre la edición real (venía por ruta
        // con :id); agrupadosHeredadosDeshabilitar cubre la reactivación por
        // código (alta sin :id). Son mutuamente excluyentes: nunca se llenan
        // los dos a la vez para el mismo guardado.
        lote = [
          ...this.productosAgrupadosOriginal.map( p => ( { ...p, indicadorHabilitado: false } ) ),
          ...this.agrupadosHeredadosDeshabilitar
        ].map( p => ( { ...p, idProductoTroncal: guardado.idProductoTroncal } ) );
      }

      const continuarConProductosAgrupados = () => {
        if ( lote.length > 0 ) {
          this.productoTroncalProductoAgrupadoServicio.crearActualizarLote( lote ).subscribe( () => {
            this.finalizarGuardado();
          }, () => {
            this.guardando = false;
          } );
        } else {
          this.finalizarGuardado();
        }
      };

      if ( this.ordenLiberado !== null ) {
        this.reorganizarTrasReactivacion( guardado.idProductoTroncal, continuarConProductosAgrupados );
      } else {
        continuarConProductosAgrupados();
      }
    }, () => {
      this.guardando = false;
    } );
  }

  finalizarGuardado() {
    this.navServicio.setMesage( this.formulario.value.idProductoTroncal ? 2 : 1 );
    this.guardando = false;
    this.location.back();
  }

  regresar() {
    if ( this.formulario.dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  get f() {
    return this.formulario.controls;
  }

}
